<template>
  <div style="height: 800px">
    <div
      style="
        width: 100%;
        height: calc(100% - 60px);
        display: flex;
        flex-direction: column;
        flex: 5;
      "
    >
      <div id="fftClChartAni"></div>
    </div>
    <div class="btnGrp">
      <div class="jcfe pr20">
        <b-form-select
          class="select-container w200"
          style="margin-right: 20px"
          :options="clusterOptions"
          label="text"
          :clearable="false"
          v-model="clusterDataIndex"
          :disabled="isDrawing"
        >
        </b-form-select>
        <button id="btnPrev" @click="moveFftClChartPrev" :disabled="isDrawing">
          <i class="fas fa-angle-left"></i>
        </button>
        <span v-if="index === 0">1</span>
        <span v-else>{{ index }}</span>
        <span> / </span>
        <span>{{ dataLength }}</span>
        <button id="btnNext" @click="moveFftClChartNext" :disabled="isDrawing">
          <i class="fas fa-angle-right"></i>
        </button>
        <b-button
          class="full-startBtn"
          @click="drawFftClChart"
          :disabled="isDrawing"
        >
          <i class="fas fa-play"></i>시작
        </b-button>
        <b-button
          class="full-stopBtn"
          @click="stopFftClChart"
          :disabled="!isDrawing"
        >
          <i class="fas fa-stop"></i>중지
        </b-button>

        <b-button class="empty-delBtn mr0" @click="closeModal">
          <i class="fa fa-window-close"></i>닫기
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import chartUtil from "../common/chartUtil";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  props: {
    clusteringData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      index: 0,
      isDrawing: false,
      dataLength: 0,
      drawCharInterval: null,
      clusterDataIndex: 0,
      clusterOptions: [],
    };
  },
  mounted() {
    console.log(this.clusteringData);
    Plotly.purge("fftClChartAni");
    this.getOptions();
    this.drawFftClChart();
  },
  methods: {
    getOptions() {
      this.clusterOptions = [];
      for (let key in this.clusteringData) {
        this.clusterOptions.push({
          value: Number(key.split("#")[1]),
          text: "cluster_#" + key.split("#")[1],
        });
      }
      this.clusterDataIndex = this.clusterOptions[0].value;
    },
    drawFftClChart() {
      Plotly.purge("fftClChartAni");

      this.isDrawing = true;
      this.index = 0;

      let data =
        this.clusteringData["fft_cluster_#" + this.clusterDataIndex].fft_cl_ani;
      this.dataLength = data.length;

      // this.drawChartWithItem(data, "fftClChartAni", 1);

      this.drawCharInterval = setInterval(() => {
        this.index++;
        this.drawChartWithItem(data, "fftClChartAni", this.index);
        if (this.index == data.length) {
          console.log("작업 종료");
          this.isDrawing = false;
          clearInterval(this.drawCharInterval);
        }
      }, 500);

      /* this.drawCharInterval = setInterval(() => {
        this.index++;
        this.drawChartWithItem(
          data[this.index - 1],
          "fftClChartAni",
          this.index
        );
        if (this.index == data.length) {
          console.log("작업 종료");
          this.isDrawing = false;
          clearInterval(this.drawCharInterval);
        }
      }, 500); */
    },
    drawChartWithItem(item, id, index) {
      // let fftClChart = [];
      let fftClChart = [
        {
          x: [],
          y: [],
          type: "scatter",
          mode: "markers",
          marker: {
            size: [],
            color: [],
          },
          center: [],
        },
      ];

      for (var i = 0; i < index; i++) {
        for (var j = 0; j < item[i].chart.data.length; j++) {
          fftClChart[0].x.push(item[i].chart.data[j][0]);
          fftClChart[0].y.push(item[i].chart.data[j][1]);
          fftClChart[0].marker.size.push(8);
          if (i != index - 1) {
            fftClChart[0].marker.color.push("#bbbbbb22");
            fftClChart[0].marker.line = {
              width: 0,
            };
          } else {
            fftClChart[0].marker.color.push(item[i].chart.data[j][2]);
            fftClChart[0].marker.line = {
              color: "white",
              width: 1,
            };
          }
        }
        fftClChart[0].center[0] = item[i].center[0];
      }

      /* item.chart.data.forEach((data) => {
        fftClChart[0].x.push(data[0]);
        fftClChart[0].y.push(data[1]);
        fftClChart[0].marker.size.push(8);
        fftClChart[0].marker.color.push(data[2]);
      }); */

      this.drawDefaultChart(id, fftClChart, { showlegend: false }, "Hz");
    },
    drawDefaultChart(id, data, options, xTitle, yTitle) {
      var layout = chartUtil.setDefaultLayout(id);

      layout.margin = {
        l: 80,
        r: 50,
        t: 20,
        b: 30,
        pad: 0,
      };

      layout.width = 1300;
      layout.height = 740;
      layout.autosize = true;
      layout.showlegend = false;

      layout.xaxis.title = xTitle;
      layout.yaxis.title = yTitle;
      layout.xaxis.range = [0, 50];

      if (options.barmode) {
        layout.barmode = options.barmode;
      }

      layout.shapes = [
        {
          type: "line",
          x0: data[0].center[0][0],
          y0: Math.min(...data[0].y),
          x1: data[0].center[0][0],
          y1: Math.max(...data[0].y),
          line: {
            color: "#BBBBBB",
            width: 1,
            dash: "solid",
          },
        },
      ];

      layout.annotations = [
        {
          x: data[0].center[0][0],
          y: Math.min(...data[0].y) - 0.0000015,
          xref: "x",
          yref: "y",
          text: String(data[0].center[0][0].toFixed(6)),
          showarrow: false,
          font: {
            size: 12,
            color: "white",
          },
        },
      ];

      Plotly.newPlot(id, data, layout);
    },
    moveFftClChartPrev() {
      if (this.index > 1) {
        this.index--;
        let data =
          this.clusteringData["fft_cluster_#" + this.clusterDataIndex]
            .fft_cl_ani;
        this.drawChartWithItem(data, "fftClChartAni", this.index);
        /* console.log(this.index);
        this.drawChartWithItem(
          this.clusteringData["fft_cluster_#" + this.clusterDataIndex]
            .fft_cl_ani[this.index - 1],
          "fftClChartAni"
        ); */
      }
    },
    moveFftClChartNext() {
      if (this.index < this.dataLength) {
        this.index++;
        let data =
          this.clusteringData["fft_cluster_#" + this.clusterDataIndex]
            .fft_cl_ani;
        this.drawChartWithItem(data, "fftClChartAni", this.index);
        /* this.drawChartWithItem(
          this.clusteringData["fft_cluster_#" + this.clusterDataIndex]
            .fft_cl_ani[this.index - 1],
          "fftClChartAni"
        ); */
      }
    },
    stopFftClChart() {
      this.isDrawing = false;
      clearInterval(this.drawCharInterval);
    },
    closeModal() {
      this.stopFftClChart();
      this.$nextTick(() => {
        this.$bvModal.hide("fftClusteringModal");
      });
    },
  },
};
</script>

<style lang="scss">
#fftClusteringModal .modal-dialog {
  max-width: 1300px;

  #fftClChartAni {
    width: 100%;
    height: 100%;

    /* .svg-container {
      width: 100%;
      height: 100%;
    } */
  }
  .btnGrp {
    #btnPrev {
      border: none;
      border-radius: 15px;
      background-color: gray;
      color: white;
      margin-right: 10px;
    }
    #btnNext {
      border: none;
      border-radius: 15px;
      background-color: gray;
      color: white;
      margin: 10px 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/analysis-history/FftClusteringModal.vue